var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-page",class:_vm.pageClassNames},[_c('div',{staticClass:"nosto_page_type",staticStyle:{"display":"none"}},[_vm._v("\n    other\n  ")]),_vm._v(" "),_c('page-content',{attrs:{"page":_vm.page,"products":_vm.products}}),_vm._v(" "),_c('div',{attrs:{"id":"ensolandingpage"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }